var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { "display-advanced": false, filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.searchByCriteria()
          }
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _vm._t("questionnaire-error"),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultado" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c(
          "div",
          { key: row.id },
          [
            _c("proposal-questionnaire-result", {
              attrs: { data: row, "is-read-only": _vm.isReadOnly },
              on: { reload: _vm.onSearchHandler, toggle: _vm.onUncheckAll }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }